<template>
  <el-cascader style="width: 100%"
    v-model="selectedOptions"
    :options="options"
    @active-item-change="handleItemChange"
    :props="props"></el-cascader>
</template>

<script>
export default {
  name: 'area-select',
  components: {},
  props: {
    value: {
      type: Array
    }
  },
  data () {
    return {
      loading: false,
      options: [],
      props: {
        value: 'value',
        children: 'children'
      }
    }
  },
  watch: {
    value: {
      handler (val) {
        if (val.length) {
          this.getAreaAll(val[0], val[1])
        } else {
          this.getprovinces()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    selectedOptions: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleItemChange (val) {
      console.log(val)
      if (val.length === 1) {
        this.getcitys(val[0])
      } else if (val.length === 2) {
        this.getareas(val[0], val[1])
      }
    },
    getAreaAll (provinceCode, cityCode) {
      this.$store.dispatch('delivery/getAreaAll', {
        payload: {
          provinceCode,
          cityCode
        },
        success: (options) => {
          this.loading = false
          this.options = options
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getprovinces () {
      this.$store.dispatch('delivery/getprovinces', {
        payload: {
          pageNum: 1,
          pageSize: 10000
        },
        success: (res) => {
          this.loading = false
          res.data.records.forEach(item => {
            item.value = item.provinceCode
            item.label = item.provinceName
            item.children = []
          })
          this.options = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getcitys (code) {
      this.$store.dispatch('delivery/getcitys', {
        payload: {
          pageNum: 1,
          pageSize: 10000,
          provinceCode: code
        },
        success: (res) => {
          this.loading = false
          res.data.records.forEach(item => {
            item.value = item.cityCode
            item.label = item.cityName
            item.children = []
          })
          let index = this.options.findIndex(i => i.value === code)
          this.options[index].children = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getareas (pcode, ccode) {
      this.$store.dispatch('delivery/getareas', {
        payload: {
          pageNum: 1,
          pageSize: 10000,
          cityCode: ccode
        },
        success: (res) => {
          this.loading = false
          res.data.records.forEach(item => {
            item.value = item.areaCode
            item.label = item.areaName
          })
          let pIndex = this.options.findIndex(i => i.value === pcode)
          let cIndex = this.options[pIndex].children.findIndex(i => i.value === ccode)
          this.options[pIndex].children[cIndex].children = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  },
  created () {
    // this.getprovinces()
  },
  mounted () { }
}
</script>
<style lang="stylus" scoped>
</style>
